import { baseApi } from "./apiConfig";

export const getPreBidCifDetails = async () => {
  try {
    const response = await baseApi.get(`/portal/v2.0/getPreBidCifDetails`);
    return response;
  } catch (error) {
    console.log("Error while fetching gettingPurchaseProfile details", error);
    throw error;
  }
};

export const getPurchaseProfileCMS = async (path) => {
  const response = await baseApi.get(
    encodeURI(`portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${path}`)
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

export const deletePurchaseProfile = async (id) => {
  const response = await baseApi.post(`portal/deleteCifTemplate/${id}`);
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

export const uploadDocsForPurchaseProfile = async (formData) => {
  const response = await baseApi.post("portal/template/uploadFile", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

export const deletePurchaseProfileDocs = async (id) => {
  const response = await baseApi.post(`portal/template/deleteFile/${id}`);
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

export const fetchPurchaseProfileDocs = async (id) => {
  const response = await baseApi.post(`portal/template/documents/${id}`);
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

